import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { KTIcon } from '../../../_metronic/helpers/components/KTIcon';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../redux/reducers/authSlice';
import { DocumentService } from '../../../services/DocumentService';
import { GetDocumentListPagingAndFilterRequest, initialGetDocumentListPagingAndFilterRequest } from '../../../models/request/document/GetDocumentListPagingAndFilterRequest';
import TableFooter from '../../../components/TableFooter';
import { GetDocumentListPagingAndFilterResponse, GetDocumentListPagingAndFilterResponseData, GetDocumentListPagingAndFilterResponseItem, initialGetDocumentListPagingAndFilterResponseData } from '../../../models/response/document/GetDocumentListPagingAndFilterResponse';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import DocumentListFilters from './Components/DocumentListFilters';
import { ExportDocumentListResponse } from '../../../models/response/document/ExportDocumentListResponse';
import { DeleteDocumentResponse } from '../../../models/response/document/DeleteDocumentResponse';
import axios from 'axios';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import StatusBadge from '../../../components/StatusBadge';
import { MenuService } from '../../../services/MenuService';
import { CompanyService } from '../../../services/CompanyService';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { loadList } from '../../../components/ColumnFilter/columnFilterOptions';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';

const DocumentList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Ayarlar > Evrak Tasarımları"
    const pageVersion = "1";
    const [data, setData] = useState<GetDocumentListPagingAndFilterResponseData>(initialGetDocumentListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetDocumentListPagingAndFilterRequest>(initialGetDocumentListPagingAndFilterRequest)

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'İndir', className: 'text-center', name: 'download', order: 0, isVisible: true },
            { title: 'Evrak Adı', name: 'name', order: 0, isVisible: true },
            { title: 'Menü', name: 'menuName', order: 0, isVisible: true },
            { title: 'Şirket', name: 'companyName', order: 0, isVisible: true },
            { title: 'Aktif', name: 'isCustomActive', order: 0, isVisible: true },
            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const deleteDocument = async () => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.documentId);

            dispatch(storeActivityIndicator(true))

            var response: DeleteDocumentResponse = await DocumentService.deleteDocument(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateDocument = async (_id: string | undefined = undefined) => {
        navigate('/document/listadd?id=' + (_id ? _id : data.items.filter(x => x.isSelected)[0].documentId));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetDocumentListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response: GetDocumentListPagingAndFilterResponse = await DocumentService.getDocumentListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.documentId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.length == data.items.filter(x => x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                x.isSelected = !isAllSelected;

                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportDocumentListResponse = await DocumentService.exportDocumentList(buildExcelRequest(filter, mode, data.items.filter(x => x.isSelected).map(x => x.documentId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Başlığa tıklayarak sıralanabilen kolonlar. İndir (buton), aktif (liste zaten
    // yalnız aktifleri getiriyor) ve oluşturan/güncelleyen bilgisi listede yok.
    const sortableColumns = ['name', 'menuName', 'companyName'];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (DocumentManager.ApplyColumnFilters) aynı.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        // İndir ve Aktif kolonları filtresiz: liste zaten yalnız aktif evrakları getiriyor.
        name: { type: 'text' },
        menuName: { type: 'select', allowEmpty: false, loadOptions: () => loadList(MenuService.getMenuList(), 'menuId', x => x.name) },
        // Şirketi boş olan evrak tüm şirketler için geneldir; "(Boş)" seçeneği bunları getirir.
        companyName: { type: 'select', loadOptions: () => loadList(CompanyService.getCompanyList({ isCompany: true }), 'companyId', x => x.name) },
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetDocumentListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        if (column == "download") {
            return (
                <td width={1} className={className} onClick={() => setItemSelected(item.documentId)} onDoubleClick={() => updateDocument(item.documentId)}>
                    <a onClick={() => downloadTemplate(item.menuName + ' > ' + item.name + '.frx')} href='javascript:;'><i className='text-primary fs-1 fa fa-download'></i></a>
                </td>
            )
        }
        else if (column == "isCustomActive") {
            return (
                <td className={className} onClick={() => setItemSelected(item.documentId)} onDoubleClick={() => updateDocument(item.documentId)}><StatusBadge text={item.isCustomActive ? "Evet" : "Hayır"} /></td>
            )
        }
        else if (column == "createdUser") {
            return (
                <td className={className} onClick={() => setItemSelected(item.documentId)} onDoubleClick={() => updateDocument(item.documentId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td className={className} onClick={() => setItemSelected(item.documentId)} onDoubleClick={() => updateDocument(item.documentId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else if (['openingBalance'].includes(column)) {
            var item2: any = item;
            return <td className={className} onClick={() => setItemSelected(item.documentId)} onDoubleClick={() => updateDocument(item.documentId)}>{Helpers.correctPrice(item2[column], 2)}</td>;
        }
        else {
            var item2: any = item;
            return <td className={className} onClick={() => setItemSelected(item.documentId)} onDoubleClick={() => updateDocument(item.documentId)}>{item2[column]}</td>;
        }
    }

    const downloadTemplate = async (fileName: string) => {
        dispatch(storeActivityIndicator(true));

        try {
            const response = await axios.get((Helpers.getEndpoint() + '/Document/DownloadTemplate?fileName=' + fileName), {
                responseType: 'arraybuffer',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const blob = new Blob([response.data], { type: 'application/octet-stream' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
        } catch (error) {
            // toast.error('Bir hata oluştu: ' + error?.toString());
            toast.error('Rapor şablonu bulunamadı!');
        }
        finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <DocumentListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    deleteFunction={deleteDocument}
                    onSearchSubmit={onSearchSubmit}
                    updateFunction={updateDocument}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.filter(x => x.isSelected).length > 0 && data.items.filter(x => x.isSelected).length == data.items.length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                            <input onChange={() => setItemSelected(item.documentId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                        </label>
                                                    </div>
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default DocumentList;